import { render } from "./Wedge.vue?vue&type=template&id=4507a304&bindings={\"img\":\"props\",\"color\":\"props\",\"rotation\":\"props\",\"angle\":\"props\",\"radius\":\"props\",\"imgInfo\":\"setup\",\"imgSize\":\"setup\",\"fullColor\":\"setup\",\"lightColor\":\"setup\",\"darkColor\":\"setup\",\"stroke\":\"setup\",\"nrOfBolts\":\"setup\",\"bolts\":\"setup\",\"getBolts\":\"setup\"}"
import script from "./Wedge.vue?vue&type=script&lang=js"
export * from "./Wedge.vue?vue&type=script&lang=js"
script.render = render

export default script